define(["jquery","rivets"],function($,rivets,nouislider){
	rivets.formatters.format=function(format){
		var i=1;
		var args=[].slice.call(arguments);
		return format.replace(/(%[a-z])/g,function(match,m){
			if (m=="%s") return args[i++];
			else if (m=="%n") return args[i].toFixed(2);
			else if (m=="%c") return rivets.formatters.currency(args[i]);
			else return m;
		});
	};
	rivets.formatters.isempty = function(v) {
		if (v == null) return true
		if (v == "") return true
		if (v instanceof Array && v.length == 0) return true
		return false
	}
	rivets.formatters["bind"]=function(fnc){
		return fnc.bind.apply(fnc,[null].concat([].slice.call(arguments,1)));
	}
	rivets.formatters["not"]=function(val){
		return !val;
	};
	rivets.formatters["eq"]=function(val,arg){
		return val==arg;
	};
	rivets.formatters["lt"]=function(val,arg){
		return val<arg;
	};
	rivets.formatters["gt"]=function(val,arg){
		return val>arg;
	};
	rivets.formatters["list"]=function(val/*,args*/){
		//check if its only one arg
		if (arguments.length==2)
			return val.indexOf(arguments[1])>=0;

		//if multiple args, loop them inside
		for (var i=1,ilen=arguments.length; i<ilen; i++){
			if (arguments[i]){
				if (val.indexOf(arguments[i])>=0)
					return true;
			}
		}
		return false;
	};
	rivets.formatters["listlast"]=function(val){
		if (val){
			if (val.length>0){
				return val[val.length-1];
			}
		}
		return "";
	};

	rivets.formatters["listcount"]=function(val){
		if (val){
			if (val.length>0){
				return val.length;
			}
		}
		return 0;
	};

	rivets.formatters["currency"]=function(val){
		val=val||0;
		var str=val.toFixed(2);
		str=str.replace(".00","");
		return str;
	};
	rivets.formatters["and"]=function(val,arg){
		return !!(val && arg);
	};

	rivets.binders['style-*'] = function(el, value){
		el.style.setProperty(this.args[0], value);
	};

	rivets.binders.append={
		publishes:true,
		priority:2000,
		bind:function(el){
	    this.callback=function(){
	    	var value=this.getValue();
	      var idx=value.indexOf(el.value);
	      if (idx+1 && !el.checked){
	        value.splice(idx,1);
	      } else if (idx<0 && el.checked) {
	        value.push(el.value);
	      }
	      //this.set(value);
				this.publish();
	    }.bind(this);
	    el[el.addEventListener?"addEventListener":"addListener"]("change",this.callback,true);
	  },
	  unbind:function(el){
	  	el[el.removeEventListener?"removeEventListener":"removeListener"]("change",this.callback,true);
	  },
	  routine:function(el,value){
	    el.checked=value.indexOf(el.value)>=0;
	    return value;
	  },
	  getValue:function(){
	  	return this.observer.value();
	  },
	};

	//HACK: this code is here because we need the scope
	var windowWidth=0;
	var mobileWidth=768;
	function window_resize(){
		windowWidth=$(window).width();
	}
	window_resize();
	$(window).on("resize",window_resize);

	rivets.binders.inject={
		bind:function(el){
			this.context=el;
			this.inject=null;
			this.active=true;
			if (el.getAttribute("data-inject-bp")=="tablet" || !el.getAttribute("data-inject-bp")) { //tablet is default rule
				this.active=windowWidth>mobileWidth;
			} else if (el.getAttribute("data-inject-bp")=="mobile" ) {
				this.active=!(windowWidth>mobileWidth);
			}
		},
		unbind:function(el){
			if (this.inject) {
				this.inject.remove();
				this.inject=null;
			}
		},
		getValue:function(){
	  	return this.observer.value();
	  },
		routine:function(el,value){
			if (value && this.active){
				setTimeout(function(){
					if (!this.inject){
						this.inject=$($(el).html().replace(/^\s+/,''));
					}
					$(this.context).after(this.inject);

					if (this.inject.is("video")){
						$(this.inject[0]).delay(10).queue(function(next){
							$(this).addClass("active");
							next();
						});
						this.inject[0].play();
					}
				}.bind(this),10);
			} else if (this.inject){
				var reinit=false;

				if (this.inject.is("video")){
					this.inject[0].pause();
				}

				//build up a closure delay queue for the old video
				//HACK: this code is async as hell and could cause problems with GC
				(function(oldinject){
					setTimeout(function(){
						if (oldinject){
							if (oldinject.is("video")){
								$(this).removeClass("active");
								oldinject[0].src="";
								oldinject[0].currentSrc="";
								reinit=true;
							}
							oldinject.remove();
						}
					}.bind(this),500);
				}.bind(this))(this.inject);
				this.inject=null;

				//if (reinit)
				//	this.inject=$($(el).html().replace(/^\s+/,''));*/
			}
			return value;
		},
	};

	rivets.binders["bemstate-*"]= function(el,value){
	  var elClass;
	  var classes=el.className.split(" ");
	  var ncls=classes[0]+"--"+this.args[0];
	  var idx;
	  if (value && classes.indexOf(ncls)==-1)
	    classes.push(ncls);
	  else if (!value && (idx=classes.indexOf(ncls))>=0)
	    classes.splice(idx,1);
	  el.className=classes.join(" ");
	}

	rivets.binders['scope-*'] = {
	  block: true,
	  priority: 5000,
	  bind: function(el) {

	 	},
	  routine:function(el,scope){
	  	//if (scope==null){
	    //	el.remove();
	    // 	return;
	    //}
			if (this.subview){
				this.subview.models[this.originalScope]=scope;
			} else if (!this.subview){
	    	var data={

	      };

	      this.originalScope=this.args[0];
	      this.originalAttr=[this.view.prefix, this.type].join('-').replace('--', '-');
	      this.originalAttrVal=el.getAttribute(this.originalAttr);
	      el.removeAttribute(this.originalAttr);

	      data[this.originalScope]=scope;
	      for (var i in this.view.models)
	        data[i]=this.view.models[i];

	      var opts=this.view.options();

	      this.subview=new rivets._.View(el,data,opts);
	      this.subview.bind();
	    } else {
				this.subview.unbind();
				this.subview.update();
			}
	  },
	  unbind:function(el){
	  	if (this.subview){
	    	this.subview.unbind();
	      this.subview=null;
	      el.setAttribute(this.originalAttr,this.originalAttrVal);
	    }
	  }
	};

	//POLYFILL RV_IF
	var oldif=rivets.binders["if"];
	rivets.binders["if"]={
		block:oldif.block,
		priority:oldif.priority,
		routine:oldif.routine,
		update:oldif.update,
		bind:function(el) {
			this.attr = [this.view.prefix, this.type].join('-').replace('--', '-');
			this.attrValue = el.getAttribute(this.attr);
			oldif.bind.call(this,el);
		},
		unbind:function(el){
			oldif.unbind.call(this,el);
			el.setAttribute(this.attr,this.attrValue);
			if (!this.bound && this.marker) {
				this.marker.parentNode.insertBefore(el, this.marker.nextSibling);
				el.parentNode.removeChild(this.marker);
				this.marker=null;
			}
		}
	};
	rivets.binders["unless"]["unbind"] = function(el) {
    return rivets.binders["if"].unbind.call(this,el);
	};

});
